import React from "react";

export const Sponsors = (props) => {
  return (
    <div id="sponsors" className="text-center">
      <div className="container">
        <div
          className="section-title"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2>SPONSORS AND SUPPORTERS</h2>
          <br></br>
          <p>
            The 11th Congress of the Alps Adria Acoustics Association is
            organized as a joint meeting with
          </p>
          <br></br>
          <div id="row" style={{ display: "flex", justifyContent: "center" }}>
            {props.data
              ? props.data.slice(0, 2).map((d, i) => (
                  <div
                    key={`${d.name}-${i}`}
                    className="col-md-6 col-sm-6 sponsors"
                  >
                    <div className="thumbnail">
                      <img src={d.img} alt="..." className="sponsors-img" />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p>{d.job}</p>
                        <h5>{d.title}</h5>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="section-title"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p>Endorsed by</p>
          <div id="row" style={{ display: "flex", justifyContent: "center" }}>
            {props.data
              ? props.data.slice(2, 3).map((d, i) => (
                  <div
                    key={`${d.name}-${i}`}
                    className="col-md-6 col-sm-6 sponsors"
                  >
                    <div className="thumbnail">
                      <img src={d.img} alt="..." className="sponsors-img" />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p>{d.job}</p>
                        <h5>{d.title}</h5>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="section-title"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p>Sponsored and supported by</p>
          <br></br>
          <div id="row" style={{ display: "flex", justifyContent: "center" }}>
            {props.data
              ? props.data.slice(3, 5).map((d, i) => (
                  <div
                    key={`${d.name}-${i}`}
                    className="col-md-6 col-sm-6 sponsors"
                  >
                    <div className="thumbnail">
                      <img src={d.img} alt="..." className="sponsors-img" />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p>{d.job}</p>
                        <h5>{d.title}</h5>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="section-title"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p>Sponsors and exhibitors</p>
          <br></br>
          <div id="row" style={{ display: "flex", justifyContent: "center" }}>
            {props.data
              ? props.data.slice(5, 8).map((d, i) => (
                  <div
                    key={`${d.name}-${i}`}
                    className="col-md-6 col-sm-6 sponsors"
                  >
                    <div className="thumbnail">
                      <img src={d.img} alt="..." className="sponsors-img" />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p style={{ fontWeight: "bold" }}>{d.job}</p>
                        <p>{d.title}</p>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
          <div id="row" style={{ display: "flex", justifyContent: "center" }}>
            {props.data
              ? props.data.slice(8, 10).map((d, i) => (
                  <div
                    key={`${d.name}-${i}`}
                    className="col-md-6 col-sm-6 sponsors"
                  >
                    <div className="thumbnail">
                      <img src={d.img} alt="..." className="sponsors-img" />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p style={{ fontWeight: "bold" }}>{d.job}</p>
                        <p>{d.title}</p>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>
    </div>
  );
};
